import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { COLOR_RED, COLOR_ORANGE } from '../../assets/styles/colors';

export const ErrorWrapSC = styled.div`
  margin-top: 24px;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  background: ${({ type }) =>
    type === 'warning'
      ? css`
          color: ${COLOR_ORANGE} !important;
          background-color: ${rgba(COLOR_ORANGE, 0.1)};
        `
      : css`
          color: ${COLOR_RED} !important;
          background-color: ${rgba(COLOR_RED, 0.1)};
        `};

  p {
    &:last-child {
      line-height: 1.25;
    }
  }
`;
